module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_3016.42fdceda.png";